import { createContext } from 'react';
import { GetMeResponseData } from '@/api';

export interface AccountSettingsContextData {
    data: GetMeResponseData;
}

export const AccountSettingsContext = createContext<
    AccountSettingsContextData | undefined
>(undefined);
